import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { router } from '@/router';
import LoginForm from './LoginForm.vue';
import LoginService from '@/core/login.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  props: {
    userNameText: null,
    passwordText: null,
    loginInformationText: null,
    loginButtonText: null,
    forgotPasswordText: null,
    forgotPasswordLink: null,
    userNotMigratedText: null,
    userNotMigratedLinkText: null,
    linkToOldLoginPage: null
  },
  emits: ['login'],
  setup(__props: any) {

const props = __props as {
    userNameText: string;
    passwordText: string;
    loginInformationText: string;
    loginButtonText: string;
    forgotPasswordText: string;
    forgotPasswordLink: string;
    userNotMigratedText: string;
    userNotMigratedLinkText: string;
    linkToOldLoginPage: string;
}





const loginErrorMessage = ref<string>('');
const showSpinner = ref<boolean>(false);
const migrationText = ref<string>('');

const login = async(userCredentials: ILoginForm) => {
    loginErrorMessage.value = '';
    showSpinner.value = true;
    const destinationUrl = router.currentRoute.query.url as string;

    const serverResponse = LoginService.login(userCredentials, destinationUrl);

    serverResponse.then(response => {
        const { isLoggedIn, redirectUrl, errorMessage, isUserMigrated } = response;

        if (isLoggedIn) {
            LoginService.loginRedirect(redirectUrl);
        } else if (!isUserMigrated) {
            buildNotMigratedText();
        } else {
            loginErrorMessage.value = errorMessage;
        }
    }).finally(() => showSpinner.value = false);
};

function buildNotMigratedText() {
    migrationText.value = props.userNotMigratedText;
    if (props.userNotMigratedLinkText) {
        migrationText.value += '<a href=' + props.linkToOldLoginPage + '>' + props.userNotMigratedLinkText + '</a>';
    }
}

return { __sfc: true,props, loginErrorMessage, showSpinner, migrationText, login, buildNotMigratedText, LoginForm }
}

})